#import "../../../../contact/graphql/fragments/email-deliverability-fragment.graphql"
#import "../../../../contact/graphql/fragments/sms-deliverability-fragment.graphql"

fragment PeepBusinessCardInfoFragment on Peep {
    id
    emailAddresses {
        all {
            id
            name
            isPrimary
            isFormer
            value {
                address
            }
            deliverabilityStatus {
                ...EmailDeliverabilityFragment
            }
        }
    }
    phones {
        all {
            id
            name
            isPrimary
            isFormer
            value {
                id
                extension
                numberFormatted
                numberFormattedWithCountryCode
            }
            deliverabilityStatus {
                ...SmsDeliverabilityFragment
            }
        }
    }
    postalAddresses {
        all {
            id
            name
            isPrimary
            isFormer
            location {
                fullPrintableAddress
                address_1
                address_2
                address_3
                city
                state
                postal_code
                country
            }
        }
    }
    urls {
        all {
            id
            name
            value
            isPrimary
            displayValue
            socialPlatform
        }
    }
}
